<template>
  <div>
    <TheHeader
      back-route="."
      with-menu
    />
    <BaseSection
      v-if="investment"
      class="mb-4"
    >
      <BaseTitleGroup
        :subtitle="`${$t('My investments')} / ${participation.attributes.name}`"
        :title="$t('Summary')"
        class="base-border-b-strong pb-6"
      />
    </BaseSection>
    <BaseSection v-if="investment">
      <CompanyDetails
        :attributes="participation.attributes"
        :spv-attributes="spv.attributes"
        :date="operation.attributes.date"
      />
    </BaseSection>
  </div>
</template>

<script>
import loadInvestment from '../mixins/loadInvestment';
import TheHeader from '../components/TheHeader.vue';
import BaseTitleGroup from '../components/BaseTitleGroup.vue';
import BaseSection from '../components/BaseSection.vue';
import CompanyDetails from './partials/CompanyDetails.vue';

export default {

  name: 'InvestmentSummary',

  components: {
    TheHeader,
    BaseTitleGroup,
    BaseSection,
    CompanyDetails,
  },

  mixins: [loadInvestment],
};
</script>
